import React, { Suspense } from "react";
import { Modal } from "antd";
import { useModalStore } from "@/hooks/useModalStore";
import { CloseIcon } from "@/components/icons";

// 将 IM 相关的内容移到一个单独的异步组件中
const AsyncImContent = React.lazy(() => import("./ImContent"));

interface Props {}

const ImModal: React.FC<Props> = () => {
  const { setShowImModal, showImModal } = useModalStore();

  return (
    <Modal
      open={showImModal}
      width={1000}
      footer={null}
      closable={false}
      styles={{
        content: {
          padding: 0,
          borderRadius: "24px",
          overflow: "hidden",
        },
      }}
    >
      <>
        <div className="w-[1000px] px-6 py-4 border-b border-[#D9D9E0] inline-flex justify-between items-center">
          <div className="justify-start text-black text-xl font-bold  leading-relaxed">
            Messages
          </div>
          <div
            className="w-6 h-6 relative cursor-pointer"
            onClick={() => setShowImModal(false)}
          >
            <CloseIcon />
          </div>
        </div>
        {showImModal && (
          <Suspense fallback={<div className="h-[50vh]">Loading IM ...</div>}>
            <AsyncImContent />
          </Suspense>
        )}
      </>
    </Modal>
  );
};

export default ImModal;
